// TODO RR OLD
export enum NotificationStatus {
	NEW = "unseen",
	SEEN = "seen",
	MARKED_AS_SEEN = "marked_as_seen",
	MARKED_AS_UNSEEN = "marked_as_unseen"
}
